import type { LucideIcon } from "lucide-react";
import { ArrowUpRight } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const toneStyles = {
  primary: "bg-primary/10 text-primary",
  accent: "bg-accent/15 text-accent-foreground",
  warning: "bg-warning/15 text-warning",
  neutral: "bg-muted text-muted-foreground",
};

export const MetricCard = ({ label, value, detail, trend, icon: Icon, tone = "primary", testId }: { label: string; value: string; detail: string; trend: string; icon: LucideIcon; tone?: keyof typeof toneStyles; testId: string }) => (
  <Card className="metric-card" data-testid={testId}>
    <CardContent className="p-5">
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-sm font-medium text-muted-foreground" data-testid={`${testId}-label`}>{label}</p>
          <p className="mt-2 text-3xl font-semibold tracking-tight text-foreground" data-testid={`${testId}-value`}>{value}</p>
        </div>
        <div className={`flex size-10 items-center justify-center rounded-lg ${toneStyles[tone]}`}>
          <Icon className="size-5" aria-hidden="true" />
        </div>
      </div>
      <div className="mt-4 flex items-center justify-between gap-2 text-xs">
        <span className="text-muted-foreground" data-testid={`${testId}-detail`}>{detail}</span>
        <span className="inline-flex items-center gap-1 font-semibold text-primary" data-testid={`${testId}-trend`}>
          {trend}<ArrowUpRight className="size-3" aria-hidden="true" />
        </span>
      </div>
    </CardContent>
  </Card>
);
